import { Autocomplete, Grid, Switch, TextField, Tooltip, Typography, useMediaQuery } from '@mui/material'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import styles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss"
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import contactStyles from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import whatsAppCampaignStyles from "../../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss"
import dataConnectorStyles from '../../../../../../assets/styles/componentStyles/dataconnector.module.scss'
import { createWebhookPayload } from './customAPIConfigPopup';
import AssignVariablesTable from './assignVariablesTable';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Required from '../../../../../utility/required';
import GlobalButton from '../../../../../utility/globalButton/button';
import { chatbotDataConnector, customVariableDataInterface, dataConnectorList, functionResponseData, getTemplateDetails, interactiveType } from '../../../../../../models/axiosModel';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import { filterAutocompleteOptionsWithException, fontColorForMethod, generateUUID, getValueOrDefault, isSystemApi, WHATSAPP_PAYMENT_INFO_SYSTEM_API } from '../../../../../../utils/constants';
import { isInstagramChannel } from '../../../../../../pages/ruleBasedInbox/channelConstants';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import GlobalTooltip from '../../../../../utility/tooltip/globalTooltip';
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore';
import RefreshIcon from '@mui/icons-material/Refresh';
import { DataConnectorContext, DataConnectorContextpayload } from '../../../../../../context/dataConnectorContext';
import PrimaryIOSSwitch from '../../../../../utility/switch/primaryIOSSwitch';
import { createNewCustomAPIObj, renderCustomAPIOptions } from '../../../flowBuilderConstants';
import agent from '../../../../../../services/api';
import { isInteractiveTypeMessageOrderDetails, renderTemplateOptions } from '../../../../channels/global/whatsapp/templates/utils';

interface dataConnectorListProps {
    dataConnectorList: dataConnectorList[],
    setDataConnectorList: React.Dispatch<React.SetStateAction<dataConnectorList[]>>,
    dataConnectorDetails: chatbotDataConnector[],
    setDataConnectorDetails: React.Dispatch<React.SetStateAction<chatbotDataConnector[]>>,
    payload: createWebhookPayload,
    setPayload: React.Dispatch<React.SetStateAction<createWebhookPayload>>,
    getChatbotDataConnectorDetailCall: (connector_id: number, flagUpdatePayloadFromActionData: boolean, flagUpdtePayload: boolean) => void,
    flagShowResponseData: boolean,
    setFlagShowResponseData: React.Dispatch<React.SetStateAction<boolean>>,
    extractResponsePaths: (data: functionResponseData[]) => functionResponseData[],
    filterAndSortFunctionParameterData: (functionParameterData: any, flagRender: boolean) => any,
}

interface testRequestResponse {
    status_code: number,
    response: any,
}

const CustomAPIConfig: React.FC<dataConnectorListProps> = (props) => {

    const { dataConnectorList, setDataConnectorList, dataConnectorDetails, payload, setPayload, getChatbotDataConnectorDetailCall, flagShowResponseData, setFlagShowResponseData, extractResponsePaths, filterAndSortFunctionParameterData } = props;
    const setFlagDataCollectionPopup = useFlowBuilderStore((state) => state.setFlagDataCollectionPopup)
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;
    const { getChatbotDataConnectorList } = useContext(DataConnectorContext) as DataConnectorContextpayload;
    const [testRequestResponse, setTestRequestResponse] = useState<testRequestResponse | null>(null);

    const label = { inputProps: { 'aria-label': 'Switch demo' } };

    const flagLaptopScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1400px)');

    const [interactiveTypeList, setInteractiveTypeList] = useState<interactiveType[] | null>(null);

    const getChatbotDataConnectorListApiCall = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const res = await getChatbotDataConnectorList();
        if (res.status && res.data) {
            setDataConnectorList(res.data);
        } else {
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }
    const onChangeOfFieldVariableTypeForFunctionParameter = useCallback((value: any, paramDataId: number) => {
        setPayload((prevState) => ({
            ...prevState,
            function_parameters: prevState.function_parameters?.map((para) => {
                if (para?.function_parameter_data_id == paramDataId) {
                    return {
                        ...para,
                        variable_type: value
                    }
                }
                return para;
            })
        }))
    }, [])
    const onChangeOfFieldForFunctionParameter = useCallback((value: customVariableDataInterface | null, paramDataId: number) => {
        if (value?.chatbot_custom_variable_configuration_id == "-1" && value?.chatbot_custom_variable_name == "New Field") {
            setFlagDataCollectionPopup(true);
        } else {
            setPayload((prevState) => ({
                ...prevState,
                function_parameters: prevState.function_parameters?.map((para) => {
                    if (para?.function_parameter_data_id == paramDataId) {
                        // @ts-ignore
                        if (para?.variable_type && para?.variable_type?.variable_type_name == "Metadata") {
                            return {
                                ...para,
                                metadata_type: value ? value : null
                            }
                        } else {
                            return {
                                ...para,
                                chatbot_custom_variable_configuration_id: value ? value.chatbot_custom_variable_configuration_id : null
                            }
                        }
                    }
                    return para;
                })
            }))
        }
    }, [])

    const onChangeOfFallbackValueForFunctionParameter = useCallback((value: string, paramDataId: number) => {
        setPayload((prevState) => ({
            ...prevState,
            function_parameters: prevState.function_parameters?.map((para) => {
                if (para?.function_parameter_data_id == paramDataId) {
                    return {
                        ...para,
                        function_parameter_fallback_value: value
                    }
                }
                return para;
            })
        }))
    }, [])

    const onChangeOfFieldForFunctionResponse = useCallback((value: customVariableDataInterface | null, resDataId: number) => {
        if (value?.chatbot_custom_variable_configuration_id == "-1" && value?.chatbot_custom_variable_name == "New Field") {
            setFlagDataCollectionPopup(true);
        } else {
            setPayload((prevState) => ({
                ...prevState,
                function_response: prevState.function_response?.map((para) => {
                    if (para?.function_response_data_id == resDataId) {
                        return {
                            ...para,
                            chatbot_custom_variable_configuration_id: value ? value.chatbot_custom_variable_configuration_id : null
                        }
                    }
                    return para;
                })
            }))
        }
    }, [])


    const onChangeOfFallbackValueForFunctionResponse = useCallback((value: string, resDataId: number) => {
        setPayload((prevState) => ({
            ...prevState,
            function_response: prevState.function_response?.map((para) => {
                if (para?.function_response_data_id === resDataId) {
                    return {
                        ...para,
                        function_response_fallback_value: value,
                    };
                }
                return para;
            }),
        }));
    }, []);
    const checkDisableTestRequest = () => {
        return payload?.function_parameters?.some((para) => {
            return para.function_parameter_fallback_value?.trim()?.length === 0;
        });
    }

    const handleTestRequestClick = async () => {
        const url = dataConnectorDetails[0]?.chatbot_data_connector_url;
        const method = dataConnectorDetails[0]?.function_method_name;
        const parameters: any = {}
        payload?.function_parameters?.map((para) => {
            parameters[para.function_parameter_name] = para.function_parameter_fallback_value;
        });

        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        try {
            const res = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: method != "GET" ? JSON.stringify(parameters) : undefined,
            });

            const data = await res.json();

            setTestRequestResponse({
                status_code: res.status,
                response: data,
            })
        }
        catch (err) {
            const isLikelyCORSError = err instanceof TypeError && err.message === "Failed to fetch";

            setTestRequestResponse({
                status_code: 0,
                response: {
                    error: isLikelyCORSError
                        ? "CORS Error: The request was blocked due to CORS policy." : err instanceof TypeError ? err.message : "Something Went Wrong.",
                },
            });
        }

        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    const getInteractiveTypeCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await agent.getInteractiveType.get();
        if(!(res.status)){
            handleError(res);
        } else {
            setInteractiveTypeList(res.data);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const getTemplateIdParam = () => {
        return payload?.function_parameters?.find((param) => param?.function_parameter_name?.toLowerCase() === 'whatsapp_template_id');
    }

    const shouldShowTemplateIdParam = () => {
        const isSystemAPI = isSystemApi(dataConnectorDetails?.[0]?.chatbot_data_connector_function_path);
        const isPaymentInfoSystemAPI = dataConnectorDetails?.[0]?.data_connector_functions?.data_connector_function_name?.toLowerCase() === WHATSAPP_PAYMENT_INFO_SYSTEM_API?.toLowerCase();
        const isWhatsAppTemplateIdParam = getTemplateIdParam();

        return Boolean(isSystemAPI && isPaymentInfoSystemAPI && isWhatsAppTemplateIdParam);
    } 

    useEffect(() => {
        if (shouldShowTemplateIdParam() && !interactiveTypeList) {
            (async() => {
                await getInteractiveTypeCall(); // get Interactive Type Call to filterout interactive order details template
            })()
        }
    }, [dataConnectorDetails, interactiveTypeList]);

    const getOrderDetailsTemplateOptions = () => {
        return currentActiveStaticWorkflow?.additional_data?.whatsapp_templates?.filter((template) => isInteractiveTypeMessageOrderDetails(template?.interactive_type?.interactive_type_id, interactiveTypeList)) ?? [];
    }

    const getTemplateIdParamValue = () => {
        const templateIdParam = getTemplateIdParam();
        if(templateIdParam){
            return getOrderDetailsTemplateOptions()?.find((template) => String(template?.whatsapp_template_id) === String(templateIdParam?.function_parameter_fallback_value)) ?? null
        }
        return null;
    }

    const getCustomAPIValue = () => {
        return dataConnectorList?.find((list: dataConnectorList) => list?.chatbot_data_connector_id == payload?.chatbot_data_connector_id) || null;
    }

    const getCustomAPIOptions = () => {
        let filteredList = dataConnectorList.filter((connector) =>
            !(!(connector?.function_method_name) && connector?.flag_allow_voice_agent_assignment)
        );

        const channelName = currentActiveStaticWorkflow?.chatbot_channel?.channel_name;
        const isInstagram = isInstagramChannel(channelName);

        if(isInstagram) {
            filteredList = filteredList?.filter((connector) => connector?.function_method_name);
        }
        
        return [...filteredList, createNewCustomAPIObj];
    }

    return (
        <>
            <Grid container gap={"15px"} className={`${globalStyles.fullwidth}`} sx={{ padding: "5px" }}>
                
                <Grid item xs={12}>
                    <Grid container gap={"20px"} flexWrap={flagLaptopScreen ? "wrap" : "nowrap"}>

                        <Grid item xs={flagLaptopScreen ? 12 : 6}>
                            <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"}>
                                <Grid item className={`${styles.createWorkflowLabelStyle} ${styles.createWorkflowFieldLabelRow}`}>
                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                        Custom API <Required />
                                        {(payload.chatbot_data_connector_id && !isSystemApi(dataConnectorDetails?.[0]?.chatbot_data_connector_function_path)) &&
                                            <Tooltip title="View Custom API in detail">
                                                <VisibilityIcon
                                                    className={globalStyles.clickable}
                                                    sx={{ fontSize: 16 }}
                                                    onClick={() => {
                                                        window.open(`${window.location.origin}/customAPI/createCustomAPI?connector_id=${payload.chatbot_data_connector_id}`, "_blank")
                                                    }}
                                                />
                                            </Tooltip>
                                        }
                                    </span>
                                </Grid>
                                <Grid item>
                                    <Grid container alignItems={"center"} gap={"5px"} wrap={"nowrap"}>
                                        <Grid item sx={{ flex: 1, minWidth: 0 }}>
                                            <Autocomplete
                                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                className={`${contactStyles.contactFilterDropdownsInPopup}`}
                                                options={getCustomAPIOptions()}
                                                getOptionLabel={(option: dataConnectorList) =>
                                                    `${option?.function_method_name ? option?.function_method_name : 'System API'} - ${option?.data_connector_functions?.data_connector_function_name || ""}`
                                                }
                                                value={getCustomAPIValue()}
                                                onChange={(_, value: dataConnectorList | null) => {
                                                    setTestRequestResponse(null);
                                                    setFlagShowResponseData(false);
                                                    if (value) {
                                                        getChatbotDataConnectorDetailCall(value.chatbot_data_connector_id, false, true);
                                                    } else {
                                                        // setDataConnectorDetails([]);
                                                        setPayload((prevState) => ({
                                                            ...prevState,
                                                            chatbot_data_connector_id: null,
                                                            function_parameters: [],
                                                            function_response: [],
                                                        }))
                                                    }
                                                }}
                                                filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "data_connector_functions?.data_connector_function_name", "chatbot_data_connector_id")}
                                                renderOption={(props, option) => renderCustomAPIOptions(props, option)}
                                                renderInput={(params) => <TextField {...params} placeholder="Select Custom API" />}
                                            />
                                        </Grid>
                                        <Grid item className={globalStyles.displayFlex} onClick={() => getChatbotDataConnectorListApiCall()}>
                                            <RefreshIcon className={`${globalStyles.primaryColor} ${globalStyles.clickable}`} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        
                        {payload.chatbot_data_connector_id &&
                            <>
                                {!isSystemApi(dataConnectorDetails?.[0]?.chatbot_data_connector_function_path) && 
                                    <Grid item xs={flagLaptopScreen ? 12 : getCustomAPIValue() ? 6: 12}>
                                        <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"}>
                                                <Grid item className={`${styles.createWorkflowLabelStyle} ${styles.createWorkflowFieldLabelRow}`}>URL</Grid>
                                            <Grid item>
                                                <TextField
                                                    value={dataConnectorDetails?.[0]?.chatbot_data_connector_url ?? ''}
                                                    placeholder='URL'
                                                    onChange={(e) => { }}
                                                    className={`${whatsAppCampaignStyles.whatsappCampaignTextField}`}
                                                    sx={{ width: "100%", minWidth: "200px", backgroundColor: "white" }}
                                                    disabled={true}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {shouldShowTemplateIdParam() && 
                                    <Grid item xs={flagLaptopScreen ? 12 : getCustomAPIValue() ? 6 : 12}>
                                        <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"}>
                                                <Grid item className={`${styles.createWorkflowLabelStyle} ${styles.createWorkflowFieldLabelRow}`}>Order Detail WhatsApp Template <Required /> </Grid>
                                            <Grid item>
                                                <Autocomplete
                                                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                    className={`${contactStyles.contactFilterDropdownsInPopup}`}
                                                    options={getOrderDetailsTemplateOptions()}
                                                    getOptionLabel={(option) => option.whatsapp_template_data?.[0].whatsapp_template_display_name ?? option.whatsapp_template_data?.[0]?.whatsapp_template_name ?? ''}
                                                    value={getTemplateIdParamValue() as getTemplateDetails | null}
                                                    onChange={(_, value: getTemplateDetails | null) => {
                                                        const templateIdParam = payload?.function_parameters?.find((param) => param?.function_parameter_name?.toLowerCase() === 'whatsapp_template_id')?.function_parameter_data_id ?? 0;
                                                        onChangeOfFallbackValueForFunctionParameter(value ? String(value?.whatsapp_template_id) : "", templateIdParam);
                                                    }}
                                                    renderOption={(props, option) => renderTemplateOptions(props, option, option.whatsapp_template_id)}
                                                    renderInput={(params) => <TextField {...params} placeholder="Select Order Detail Template" />}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                            </>
                        }
                    </Grid>
                </Grid>

                {/* {dataConnectorDetails.length > 0 && */}
                {payload.chatbot_data_connector_id &&
                    <>
                        {payload.function_parameters?.length > 0 &&
                            <Grid item className={globalStyles.fullwidth} sx={{ backgroundColor: "#F4F4F4", padding: "0px 10px", borderRadius: "5px" }}>
                                <Grid item className={`${globalStyles.fullwidth}`} sx={{ marginBlock: '10px' }}>
                                    <AssignVariablesTable
                                        // tableData={dataConnectorDetails[0]?.data_connector_functions?.data_connector_function_parameters?.function_parameter_data}
                                        tableData={filterAndSortFunctionParameterData(dataConnectorDetails[0]?.data_connector_functions?.data_connector_function_parameters?.function_parameter_data, true)}
                                        payload={payload.function_parameters}
                                        setPayload={setPayload}
                                        onChangeOfField={onChangeOfFieldForFunctionParameter}
                                        onChangeOfFallbackValue={onChangeOfFallbackValueForFunctionParameter}
                                        onChangeOfFieldVariableTypeForFunctionParameter={onChangeOfFieldVariableTypeForFunctionParameter}
                                    />
                                </Grid>
                            </Grid>
                        }

                        <Grid item>
                            <Grid container gap={"10px"} className={`${globalStyles.alignItemCenter}`}>
                                <Grid item>
                                    <GlobalButton

                                        className='primaryButtonStyle'
                                        buttonText="Test Your Request"
                                        sx={{ fontSize: "14px !important" }}
                                        disabled={checkDisableTestRequest() || isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                        onClick={() => handleTestRequestClick()}
                                    />
                                </Grid>
                                <Grid item className={`${globalStyles.displayFlexStyle} ${globalStyles.clickable}`}>
                                    <GlobalTooltip
                                        title="If your request contains variables, you have to manually set their fallback values for testing purposes."
                                        placement='top'
                                        children={<InfoOutlinedIcon className={styles.iButton} />}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        {(dataConnectorDetails[0]?.data_connector_functions?.data_connector_function_response?.function_response_data?.length > 0) &&
                            <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"}>
                                <Grid item>
                                    <Grid container gap={"10px"} className={`${globalStyles.alignItemCenter}`}>
                                        <Grid item className={styles.createWorkflowLabelStyle}>
                                            Save Response in Variable
                                        </Grid>
                                        <Grid item>
                                            <PrimaryIOSSwitch
                                                // className={styles.flagAdminOnlySwitch}
                                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                checked={flagShowResponseData}
                                                onChange={(e) => {
                                                    setFlagShowResponseData(e.target.checked)
                                                    setPayload((prevState) => ({
                                                        ...prevState,
                                                        function_response: e.target.checked ? extractResponsePaths(dataConnectorDetails[0]?.data_connector_functions?.data_connector_function_response?.function_response_data)?.sort((a: any, b: any) => a.function_response_data_id - b.function_response_data_id)?.map((res: any) => {
                                                            return {
                                                                function_response_data_id: res.function_response_data_id,
                                                                action_custom_api_call_response_variable_id: generateUUID(),
                                                                function_response_name: res.function_response_name,
                                                                function_response_name_path: res?.function_response_name_path ?? '',
                                                                function_response_fallback_value: "",
                                                                chatbot_custom_variable_configuration_id: null,
                                                                action_custom_api_call_response_variable_path: res.path,
                                                            }
                                                        }) : [],
                                                    }))
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {flagShowResponseData &&
                                    <Grid item className={globalStyles.fullwidth} sx={{ backgroundColor: "#F4F4F4", padding: "0px 10px", borderRadius: "5px" }}>
                                        <Grid item className={`${globalStyles.fullwidth}`} sx={{ marginBlock: '10px' }}>
                                            <AssignVariablesTable
                                                tableData={extractResponsePaths(dataConnectorDetails[0]?.data_connector_functions?.data_connector_function_response?.function_response_data)}
                                                payload={payload.function_response}
                                                setPayload={setPayload}
                                                onChangeOfField={onChangeOfFieldForFunctionResponse}
                                                onChangeOfFallbackValue={onChangeOfFallbackValueForFunctionResponse}
                                            />
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                        }



                        {testRequestResponse &&
                            <>
                                <Grid item className={globalStyles.fullwidth}>
                                    <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"}>
                                        <Grid item className={styles.createWorkflowLabelStyle}>Status Code</Grid>
                                        <Grid item>
                                            <TextField
                                                value={testRequestResponse?.status_code}
                                                placeholder='URL'
                                                onChange={(e) => { }}
                                                className={whatsAppCampaignStyles.whatsappCampaignTextField}
                                                sx={{ width: "100%", minWidth: "200px", backgroundColor: "white" }}
                                                disabled={true}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item className={globalStyles.fullwidth}>
                                    <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"}>
                                        <Grid item className={styles.createWorkflowLabelStyle}>Response</Grid>
                                        <Grid item>
                                            <textarea
                                                placeholder='Test Response'
                                                value={JSON.stringify(testRequestResponse?.response, null, 2)}
                                                onChange={(event) => { }}
                                                dir="auto"
                                                disabled={true}
                                                className={`${dataConnectorStyles.text_area_style} ${dataConnectorStyles.minHeight300} ${dataConnectorStyles.dataConnectorDescription} ${styles.testResponseTextArea}`}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>
                        }
                    </>
                }
            </Grid>
        </>
    )
}

export default CustomAPIConfig
